import utils from './utils';

const isAndroid = utils.isAndroid();

export default function px2dp(uiElementPx) {
  return uiElementPx * 1 / 2;
}

export function px2dpSmall(uiElementPx) {
  return uiElementPx;
}

//一倍像素图,
export function pxdp(uiElementPx) {
  return uiElementPx;
}

// Android原值适配，iOS比例适配，向下取整。
export function aiDp(dp) {
  if (isAndroid) {
    return dp;
  }
  return Math.floor(dp);
}




// WEBPACK FOOTER //
// ./utils/px2dp.js